const MapIconSvg = ({
  width = 20,
  height = 20,
  viewBox = '0 0 20 20',
  className = '',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <mask
        id="mask0_41784_64945"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path
          d="M19.25 19.25V0.75H0.75V19.25H19.25Z"
          fill="white"
          stroke="white"
          stroke-width="1.5"
        />
      </mask>
      <g mask="url(#mask0_41784_64945)">
        <path
          d="M17.1164 10.3296C17.0088 9.94125 16.8482 9.49111 16.9732 9.21623C17.1337 8.86319 17.321 8.30898 17.7433 7.95696C17.9272 7.80365 18.0298 7.56002 18.015 7.31002C18.0067 7.1708 18.0268 7.0235 18.1139 6.91226C18.2595 6.72643 18.5056 6.39378 18.6628 6.17978C18.7514 6.05912 18.7606 5.89175 18.6859 5.76058L18.4002 5.259C18.329 5.13399 18.2037 5.05176 18.0676 5.05323C17.8953 5.0551 17.766 5.18148 17.7328 5.34299C17.6808 5.5957 17.5346 6.08437 17.155 6.328C16.9443 6.46318 16.7588 6.54418 16.6121 6.59273C16.4161 6.65759 16.2694 6.83087 16.2193 7.04501C16.1694 7.25823 16.0605 7.5135 15.824 7.67726C15.3544 8.00253 14.7504 8.5928 14.482 8.01455C14.2136 7.4363 14.4485 6.85805 13.8222 6.4605C13.1959 6.06296 12.5472 6.62915 12.1446 6.328C11.874 6.12557 11.5176 5.84699 11.3129 5.68605C11.2079 5.60347 11.0806 5.56142 10.9507 5.56588C10.2067 5.59151 9.37908 5.53734 8.56348 5.44368"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.42114 5.28792C6.05282 5.07445 4.86019 4.79862 4.35507 4.67547C4.22063 4.6427 4.08813 4.73182 4.05281 4.87529C4.00745 5.0593 3.92161 5.26268 3.76796 5.20752C3.61799 5.15366 3.55878 5.00762 3.53577 4.88925C3.51515 4.78329 3.4393 4.70008 3.34109 4.67687C3.33786 4.6761 3.33463 4.67532 3.33143 4.67459C3.14168 4.62962 2.95408 4.75798 2.9109 4.96202L2.60728 6.39696C2.55643 6.63729 2.52728 6.88208 2.52079 7.12846C2.50486 7.73494 2.51198 8.90508 2.74905 9.78697C2.80614 9.99928 2.91426 10.191 3.06094 10.3456C3.25588 10.5511 3.55447 10.9187 3.71564 11.3812C3.79968 11.6223 3.99309 11.8012 4.22572 11.8608C4.48313 11.9267 4.8035 12.0459 5.00938 12.2549C5.34381 12.5946 6.17612 12.7847 6.92058 12.7428C7.21833 12.726 7.50361 12.8813 7.65916 13.1553C7.73533 13.2895 7.79816 13.4464 7.81647 13.6163C7.86108 14.0296 8.34 13.9981 8.67382 13.8522C8.84291 13.7783 9.03645 13.8376 9.14738 13.9937C9.23629 14.1188 9.32287 14.2867 9.35982 14.4957C9.42614 14.8706 9.65212 15.1805 9.99686 15.3158C10.1785 15.3871 10.3714 15.2511 10.3822 15.0431C10.3978 14.7443 10.5029 14.3449 10.9367 14.2427C11.3504 14.1452 11.5773 13.9874 11.6951 13.8715C11.8323 13.7366 11.992 13.6316 12.1658 13.561C12.6581 13.3607 13.5617 13.0875 14.2401 13.4235C14.3526 13.4792 14.4768 13.5001 14.5999 13.4858C14.8264 13.4596 15.1877 13.4614 15.3431 13.7006C15.5385 14.0013 15.6642 14.5772 16.197 14.9842C16.3897 15.1315 16.6573 15.0812 16.7956 14.8749L16.8682 14.7667C16.9961 14.5759 16.9899 14.3424 16.8651 14.1793C16.5909 13.8204 16.1525 13.1721 16.1372 12.6766C16.1247 12.2742 16.4069 11.8868 16.6827 11.5599"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};
export default MapIconSvg;
